import type { Object3D } from 'three';
import type {
	SketchEntityReferenceTag,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferenceIds';

export type {
	SketchEntityReferenceTag,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferenceIds';

const SKETCH_ENTITY_REFERENCE_TAG_KEY = 'sketchEntityReferenceTag';

/**
 * 创建草图实体引用记录 id。
 *
 * @returns 新的引用记录 id。
 */
export function createSketchEntityReferenceId(): string {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	return `sketch-entity-reference-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 读取对象上的草图实体引用标记。
 *
 * @param object 场景对象。
 * @returns 命中时返回标记，否则返回 null。
 */
export function readSketchEntityReferenceTag(
	object: Object3D | null | undefined,
): SketchEntityReferenceTag | null {
	const candidate = object?.userData?.[SKETCH_ENTITY_REFERENCE_TAG_KEY];
	if (!candidate || typeof candidate.referenceId !== 'string' || candidate.isReferencedEntity !== true) {
		return null;
	}

	return {
		referenceId: candidate.referenceId,
		isReferencedEntity: true,
	};
}

/**
 * 向目标对象写入草图实体引用标记。
 *
 * @param object 目标对象。
 * @param tag 引用标记。
 */
export function writeSketchEntityReferenceTag(
	object: Object3D,
	tag: SketchEntityReferenceTag,
): void {
	object.userData[SKETCH_ENTITY_REFERENCE_TAG_KEY] = {
		referenceId: tag.referenceId,
		isReferencedEntity: true,
	};
}

/**
 * 清理对象上的草图实体引用标记。
 *
 * @param object 目标对象。
 */
export function clearSketchEntityReferenceTag(object: Object3D): void {
	if (SKETCH_ENTITY_REFERENCE_TAG_KEY in object.userData) {
		delete object.userData[SKETCH_ENTITY_REFERENCE_TAG_KEY];
	}
}
